import React from "react";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import {catalogItemMediaStackMq} from "../../utils/compositionMediaUtils";

export const CATALOG_MODULES_VIEW_2D = "2d";
export const CATALOG_MODULES_VIEW_3D = "3d";

/** Место справа на плашке «Вид» под переключатель 2D/3D (absolute top-right на превью). */
export const CATALOG_MODULES_VIEW_TOGGLE_OVERLAY_RESERVE_PX = 132;

const catalogModulesViewToggleGroupSx = {
    flexShrink: 0,
    borderRadius: "8px",
    overflow: "hidden",
    border: (theme) => `1px solid ${theme.palette.primary.main}`,
    bgcolor: (theme) => theme.palette.primary.lightGrey,
    "& .MuiToggleButtonGroup-grouped": {
        margin: 0,
        borderRadius: 0,
        borderTop: "none !important",
        borderRight: "none !important",
        borderBottom: "none !important",
        "&:not(:first-of-type)": {
            marginLeft: 0,
            borderLeft: (theme) => `1px solid ${theme.palette.primary.main} !important`,
        },
        "&:first-of-type": {
            borderLeft: "none !important",
        },
    },
};

const catalogModulesViewToggleButtonSx = {
    textTransform: "none",
    flexShrink: 0,
    minWidth: 0,
    px: "8px",
    py: "8px",
    whiteSpace: "nowrap",
    color: "text.primary",
    bgcolor: "transparent",
    borderTop: "none !important",
    borderRight: "none !important",
    borderBottom: "none !important",
    borderRadius: "0 !important",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: 1.3,
    "&.Mui-selected": {
        bgcolor: (theme) => theme.palette.primary.light,
        color: "text.primary",
        fontWeight: 600,
    },
    "&.Mui-selected:hover": {
        bgcolor: (theme) => theme.palette.primary.light,
    },
    "&:hover": {
        bgcolor: (theme) => theme.palette.primary.lightGrey,
    },
    "&.Mui-disabled": {
        opacity: 0.5,
        color: "text.primary",
    },
    [catalogItemMediaStackMq]: {
        fontSize: "14px",
        px: "8px",
        py: "6px",
    },
};

export default function CatalogModulesViewModeToggle({
    value,
    onChange,
    disabled = false,
}) {
    return (
        <ToggleButtonGroup
            exclusive
            value={value}
            disabled={disabled}
            onChange={(_event, next) => {
                if (next != null) {
                    onChange(next);
                }
            }}
            aria-label="Вид списка шкафов"
            sx={catalogModulesViewToggleGroupSx}
        >
            <ToggleButton
                value={CATALOG_MODULES_VIEW_2D}
                aria-label="2D"
                sx={catalogModulesViewToggleButtonSx}
            >
                2D
            </ToggleButton>
            <ToggleButton
                value={CATALOG_MODULES_VIEW_3D}
                aria-label="3D"
                sx={catalogModulesViewToggleButtonSx}
            >
                3D
            </ToggleButton>
        </ToggleButtonGroup>
    );
}
